export function sendMail(data) {
    var myHeaders = new Headers ();
    myHeaders.append ( "Content-Type" , "application/json" );

    var raw = JSON.stringify ( data );

    var requestOptions = {
        method : 'POST' ,
        headers : myHeaders ,
        body : raw ,
        redirect : 'follow'
    };
    return fetch ( "https://prodaja.lo.co.me/putnotest/api/sendmail.php" , requestOptions )
        .then ( response => response.text () )
        .then ( result => result )
        .catch ( error => console.log ( 'error' , error ) );
}


export function checkCode(data) {
    var myHeaders = new Headers ();
    myHeaders.append ( "Content-Type" , "application/json" );

    var raw = JSON.stringify ( data );

    var requestOptions = {
        method : 'POST' ,
        headers : myHeaders ,
        body : raw ,
        redirect : 'follow'
    };
    return fetch ( "https://prodaja.lo.co.me/putnotest/api/checkVerificationCode.php" , requestOptions )
        .then ( response => response.text () )
        .then ( result => result )
        .catch ( error => console.log ( 'error' , error ) );
}

export function createCalc(data) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept-Charset", "UTF-8");

    var raw = JSON.stringify(data);
    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    return fetch("https://prodaja.lo.co.me/putnotest/api/create_nezgoda", requestOptions)
        .then(response => response.text())
        .then(result => result)
        .catch(error => console.log('error', error));

}